import { useEffect, useState } from "react";
import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Switch } from "antd";
import { showNotificationTopEnd } from "../../../../util/utils";
import { DASHBOARD_META_TEMPLATE, GENERAL } from "../../../../constants/AppConstants";

const { Option } = Select;

export default function MetaTemplateModalForm(props) {
    const { visible, onClose, initialValues = null, onSubmit } = props;
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const isEdit = Boolean(initialValues);


    useEffect(() => {
        if (visible) {
            form.resetFields();
            if (isEdit) {
                form.setFieldsValue(initialValues);
            }
        }
    }, [visible, initialValues, isEdit, form]);


    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const response = await onSubmit(values);
            if (response?.status === 200) {
                form.resetFields();
                onClose();
                showNotificationTopEnd("success", isEdit ? "Template actualizado" : "Template agregado");
            } else {
                showNotificationTopEnd("error", response?.data?.message || "Error al guardar");
            }
        } catch (error) {
            console.log("Errores de validación:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal
            title={
                isEdit
                    ? DASHBOARD_META_TEMPLATE.ACTIONS.TOOLTIPS.EDIT +
                    GENERAL.SPACE +
                    DASHBOARD_META_TEMPLATE.TITLE_SIMPLE
                    : DASHBOARD_META_TEMPLATE.ACTIONS.TOOLTIPS.ADD +
                    GENERAL.SPACE +
                    DASHBOARD_META_TEMPLATE.TITLE_SIMPLE
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnHidden
        >
            <Form form={form} layout="vertical" initialValues={{ active: true, onlyTicketsOnMessage: true }}>
                <Row>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item label={DASHBOARD_META_TEMPLATE.COLUMNS.ID} name="templateMetaId">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.ACTION_TYPE}
                            name="action"
                            rules={[{ required: true, message: "Tipo de accion requerida (interna)" }]}
                        >
                            <Select>
                                <Option value="reserva_tickets">Reserva de tickets</Option>
                                <Option value="compra_tickets">Compra de tickets</Option>
                                <Option value="cancelacion_tickets">Cancelacion de tickets</Option>
                                <Option value="bloqueo_usuario">Bloqueo de usuario</Option>
                                <Option value="otro">Otro</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={24}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.TEMPLATE_NAME}
                            name="templateName"
                            rules={[{ required: true, message: "Nombre del template requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.CATEGORY}
                            name="category"
                            rules={[{ required: true, message: "Categoria requerida" }]}
                        >
                            <Select>
                                <Option value="marketing">Marketing</Option>
                                <Option value="utilidad">Utilidad</Option>
                                <Option value="autenticacion">Autenticacion</Option>
                                <Option value="otro">Otro</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.LANGUAGE}
                            name="language"
                            rules={[{ required: true, message: "Idioma requerido" }]}
                        >
                            <Select>
                                <Option value="es_MX">Español (Mexico)</Option>
                                <Option value="en_US">English (USA)</Option>
                                <Option value="es_ES">Español (España)</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.AMOUNT_CHARACTERS}
                            name="amountCharacters"
                            rules={[{ required: true, message: "Cantidad de caracteres en template requerida" }]}
                        >
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.MAX_CHARACTERS}
                            name="maxCharacters"
                            rules={[{ required: true, message: "Cantidad maxima de caracteres requerida" }]}
                        >
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.ONLY_TICKETS_ON_MESSAGE}
                            valuePropName="checked"
                            name="onlyTicketsOnMessage"
                        >
                            <Switch
                                checkedChildren="Sí"
                                unCheckedChildren="No"
                            />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_META_TEMPLATE.COLUMNS.STATUS}
                            valuePropName="checked"
                            name="active"
                        >
                            <Switch
                                checkedChildren="Activo"
                                unCheckedChildren="Inactivo"
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button type="primary" onClick={handleSubmit} loading={loading} block>
                        {isEdit
                            ? DASHBOARD_META_TEMPLATE.ACTIONS.TOOLTIPS.UPDATE
                            : DASHBOARD_META_TEMPLATE.ACTIONS.TOOLTIPS.SAVE}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}